import { render, staticRenderFns } from "./LiveStatusDropdown.vue?vue&type=template&id=473b763c&scoped=true"
import script from "./LiveStatusDropdown.vue?vue&type=script&lang=js"
export * from "./LiveStatusDropdown.vue?vue&type=script&lang=js"
import style0 from "./LiveStatusDropdown.vue?vue&type=style&index=0&id=473b763c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b763c",
  null
  
)

export default component.exports